import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({
    // State Variables - The Data of our App    
    state: {
        User: {},
        salesstages: [],
        interaction_types: [],
        organization_types: []
    }
})